<script setup lang="ts">
interface ContactProps {
  id: number;
  first_name?: string;
  last_name?: string;
}

defineProps<{ contact: ContactProps }>();
</script>
<template>
  <NuxtLink :to="`/partner-portal/contacts?search=id:${contact.id}`">
    {{ contact.first_name }}
    {{ contact.last_name }}
  </NuxtLink>
</template>
